import { useId } from 'react';
import { t } from '../i18n/idioma';
import { METAL_DO_SELO, SELO_ESTRELA, SELO_FITAS, nivelDoSelo } from '../look/seloFundador';

const PACK = ['', 'peregrino', 'cavaleiro', 'lorde'] as const;

/** O selo de fundador (techspec-correio §05) ao lado do nome: no chat, no perfil, na inspeção e no correio. */
export function SeloFundador({ nivel, className = 'selo-fundador' }: { nivel: number | null | undefined; className?: string }) {
  const id = useId();
  const n = nivelDoSelo(nivel);
  if (!n) return null;
  const m = METAL_DO_SELO[n];
  const rotulo = t(`correio.selo.${PACK[n]}`);
  return (
    <svg className={className} viewBox="-7 -6.5 14 15" role="img" aria-label={rotulo}>
      <title>{rotulo}</title>
      <defs>
        <radialGradient id={`${id}g`} cx="0.36" cy="0.32" r="0.75">
          <stop offset="0" stopColor={m.claro} />
          <stop offset="0.55" stopColor={m.base} />
          <stop offset="1" stopColor={m.escuro} />
        </radialGradient>
      </defs>
      <path d={SELO_FITAS} fill="#8a1f1a" stroke="rgba(0,0,0,.85)" strokeWidth={1.4} strokeLinejoin="round" />
      <circle cx={0} cy={0} r={4.6} fill={`url(#${id}g)`} stroke="rgba(0,0,0,.85)" strokeWidth={1.4} />
      <path d={SELO_ESTRELA} fill={m.escuro} />
    </svg>
  );
}
